const state = {
    dataGrid: {
        colFilter: null,
        colSort: [],
        mandate: null,
        pageNumber: null,
        pageSize: null,
        isActive: null
    },
};

const getters = {
    getColFilter: state => {
        return state.dataGrid.colFilter;
    },
    getColSort: state => {
        return state.dataGrid.colSort;
    },
    getMandate: state => {
        return state.dataGrid.mandate;
    },
    getPageNumber: state => {
        return state.dataGrid.pageNumber;
    },
    getPageSize: state => {
        return state.dataGrid.pageSize;
    },
    getActiveStatus: state => {
        return state.dataGrid.isActive;
    }
};

const mutations = {
    setColFilter: (state, payload) => {
        state.dataGrid.colFilter = payload;
    },
    setColSort: (state, payload) => {
        state.dataGrid.colSort = payload;
    },
    setMandate: (state, payload) => {
        state.dataGrid.mandate = payload;
    },
    setPageNumber: (state, payload) => {
        state.dataGrid.pageNumber = payload;
    },
    setPageSize: (state, payload) => {
        state.dataGrid.pageSize = payload;
    },
    setActiveStatus: (state, payload) => {
        state.dataGrid.isActive = payload;
    }
};

const actions = {
    setColFilter: ({ commit }, payload) => {
        commit('setColFilter', payload);
    },
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}